import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "navbar navbar-dark bg-dark navbar-expand-lg bg-light" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarTogglerDemo01",
  "aria-controls": "navbarTogglerDemo01",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1)
const _hoisted_4 = {
  class: "collapse navbar-collapse",
  id: "navbarTogglerDemo01"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Horsis logo",
  width: "30",
  height: "30",
  class: "d-inline-block align-text-top"
}, null, -1)
const _hoisted_6 = { class: "navbar-nav me-auto mb-2 mb-lg-0" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = { class: "nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "navbar-brand",
          href: "#"
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _createTextVNode(" Horsis ")
          ]),
          _: 1
        }),
        _createElementVNode("ul", _hoisted_6, [
          _createElementVNode("li", _hoisted_7, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Network")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_8, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/about"
            }, {
              default: _withCtx(() => [
                _createTextVNode("About")
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}